import { render } from "./RestaurantWrap.vue?vue&type=template&id=189681fc"
import script from "./RestaurantWrap.vue?vue&type=script&lang=js"
export * from "./RestaurantWrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__